import * as React from 'react';
export const browserbaseSvg = React.forwardRef(function browserbaseSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FF4300',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm21.906 6 3.509 3.478v3.768l-2.339 2.318 2.924 2.9v4.057L22.492 26H7V6h14.906Zm-9.041 12.045v1.468h5.923v-1.468h-5.924Zm0-6.44v1.47h5.923v-1.47h-5.924Z',
      fill: '#fff',
    }),
  );
});
browserbaseSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var browserbase = {
  category: 'brand',
  colorable: false,
  name: 'browserbase',
  svg: browserbaseSvg,
};
